import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { logout, setAuthAvailability } from '../../../../../../actions/auth'
import { updateMyAvailability } from '../../../../../../helpers/user-helper';

export const UserMenuActionItems = ({ show, onItemClick }) => {

    const getInitials = (text = '') => {
        const safeText = String(text || '').trim();
        if (!safeText) {
            return 'US';
        }

        const words = safeText.split(/\s+/).filter(Boolean);
        if (words.length === 1) {
            return words[0].slice(0, 2).toUpperCase();
        }

        return `${words[0][0] || ''}${words[1][0] || ''}`.toUpperCase();
    }

    const { id, name, email, token, available = true, photoUrl = '' } = useSelector( state => state.auth)
    const { subscription } = useSelector( state => state.company)
    const navigate = useNavigate();
    const [isUpdatingAvailability, setIsUpdatingAvailability] = React.useState(false);
    let dispatch = useDispatch()

    const closeMenu = () => {
        if (typeof onItemClick === 'function') {
            onItemClick();
        }
    };

    const handleLogout = () => {
        closeMenu();
        dispatch( logout() )
    }
    
    const handleGoNotifications = () => {
        closeMenu();
        navigate('/notifications')
    }

    const handleGoAccountSettings = () => {
        closeMenu();
        navigate('/settings/account')
    }

    const handleGoMyProfile = () => {
        closeMenu();
        navigate('/settings/profile')
    }

    const handleAvailabilityChange = async (event) => {
        const nextAvailability = Boolean(event.target.checked);

        if (!token || !id || isUpdatingAvailability) {
            return;
        }

        setIsUpdatingAvailability(true);

        const resp = await updateMyAvailability(token, nextAvailability);

        if (resp?.success) {
            dispatch(setAuthAvailability(nextAvailability));
        }

        setIsUpdatingAvailability(false);
    }

    return (
        <div className={`dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown ${show ? 'show' : ''}`}>
            <div className="dropdown-header">
                <div className="d-flex align-items-center">
                    <div className="user-menu-avatar-wrap">
                        {photoUrl ? (
                            <img src={photoUrl} alt="user-image" className="img-fluid user-avtar" />
                        ) : (
                            <span className="user-menu-avatar-fallback">{getInitials(name)}</span>
                        )}
                        <span
                            className={`user-menu-avatar-status-dot ${available ? 'is-available' : 'is-unavailable'}`}
                            aria-hidden="true"
                        />
                    </div>
                    <div>
                        <h6 className="text-dark mb-0">{name}</h6>
                        <span className="fs-12 fw-medium text-muted">{email}<span className="badge bg-soft-success text-success ms-1">{subscription}</span></span>
                    </div>
                </div>
            </div>
            <div className="dropdown px-3 py-2">
                <div className="d-flex align-items-center justify-content-between gap-3 user-menu-availability-row">
                    <span className="hstack">
                        <i className={`wd-10 ht-10 border border-2 border-gray-1 ${available ? 'bg-success' : 'bg-danger'} rounded-circle me-2`} />
                        <span style={{fontSize: 13, color: '#283C50', fontWeight: 600}}>{available ? 'Disponible' : 'No disponible'}</span>
                    </span>

                    <div className="form-check form-switch mb-0 user-menu-availability-switch">
                        <input
                            className="form-check-input user-menu-availability-switch__input"
                            type="checkbox"
                            role="switch"
                            checked={Boolean(available)}
                            disabled={isUpdatingAvailability}
                            onChange={handleAvailabilityChange}
                            aria-label="Cambiar disponibilidad"
                        />
                    </div>
                </div>
            </div>
            <div className="dropdown-divider"></div>
            <button type="button" className="dropdown-item bg-transparent" onClick={handleGoMyProfile}>
                <i className="feather-user"></i>
                <span>Mi perfil</span>
            </button>
            <button type="button" className="dropdown-item bg-transparent" onClick={closeMenu}>
                <i className="feather-activity"></i>
                <span>Actividad</span>
            </button>
            <button type="button" className="dropdown-item bg-transparent" onClick={handleGoNotifications}>
                <i className="feather-bell"></i>
                <span>Notificaciones</span>
            </button>
            <button type="button" className="dropdown-item bg-transparent" onClick={handleGoAccountSettings}>
                <i className="feather-settings"></i>
                <span>Configuración de la Cuenta</span>
            </button>
            <div className="dropdown-divider"></div>
            <button type="button" className="dropdown-item bg-transparent" onClick={handleLogout}>
                <i className="feather-log-out"></i>
                <span>Cerrar sesión</span>
            </button>
        </div>
    )
}
